export class Httpheaders{
   
    public Nonce:string;
    public Timestamp:string;
    public signature:string;
    public X_USER_TOKEN:string;
    public X_TOKEN:string;
    public X_CLIENT_ID?:string;
    public X_AUTH_TOKEN?:string;
    public accessToken?:string;
    public accessKey:string;
  
  
  }